module.exports = __webpack_public_path__ + "img/full_map_mx.e7c7b0ee.png";